import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '@capturum/auth';
import { LoginConfig } from '../login.config';
import { LoginService } from '../login.service';
import { LoginAction } from '../base/login-action.enum';
import { LoginConfigService } from '../login-config.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'cap-login',
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoginComponent implements OnInit {
  public form: FormGroup;
  public loginError: boolean;
  public loginBusy: boolean;
  public config$: Observable<LoginConfig>;

  public constructor(
    private configService: LoginConfigService,
    private authService: AuthService,
    private loginService: LoginService,
  ) {
    this.loginError = false;
    this.loginBusy = false;
  }

  public ngOnInit(): void {
    this.config$ = this.configService.getConfig();
    this.createForm();
  }

  /**
   * Submit login form
   */
  public onSubmit(): void {
    if (this.loginBusy) {
      return;
    }

    this.loginError = false;

    if (this.form.valid) {
      this.loginBusy = true;

      const lastFetchDate = localStorage.getItem('last_data_fetched_at');
      const { email, password, remember } = this.form.value;
      let options: { remember: boolean, last_data_fetched_at?: string } = { remember };

      if (lastFetchDate) {
        options = { ...options, last_data_fetched_at: lastFetchDate };
      }

      this.authService.login(email, password, options).subscribe(
        (response) => {
          this.loginService.setAction(LoginAction.login, true);
          this.loginService.onLoginSuccess(response);
        },
        (error) => {
          this.loginService.setAction(LoginAction.login, false, error.status);
          this.loginService.onLoginFail(error);
          this.loginError = true;
          this.loginBusy = false;
        }
      );
    }
  }

  /**
   * Create fields for login form
   */
  private createForm(): void {
    this.form = this.loginService.loginForm;
  }
}
